import React from 'react'
import GroupItemsList from '../GroupItemsList'

import items from './instalacionesItems'

const InstalacionesList = (props) => (
    <GroupItemsList title={"Instalaciones"} groupItems={items}/>
)

export default InstalacionesList
